// React Imports
import React, { useEffect } from 'react';

import Wait from '@react/react-spectrum/Wait';


/**
 * Component for displaying the Already Registered Error Page.
 *
 * This component displays an error message and provides links to the various sites.
 *
 * @component
 * @example
 *
 * return (
 *   <ErrorAlreadyRegistered />
 * )
 */

const BlankLoader = () => {

  useEffect(()=>{
    window.location.href = window.apcConfig.partner.apc_direct_login;
  },[]);

  return (
    <div>
      <Wait size="L" centered/>
    </div>
  );
};

export default BlankLoader;
